import { BaseRowStore } from "../../tablestore";
import { TreeTableStore } from "../TreeTableStore";
import { _ } from "ynf-core-middleware";
import { DataState, _STATUS } from "../../tablestore/types";

export class NodeStore  extends BaseRowStore<TreeTableStore>{
  _parent?: NodeStore;
  constructor(treeTableStore: TreeTableStore, src: any, parent?: NodeStore) {
    super(treeTableStore, src)
    this._parent = parent
    // 树结构处理
    this.initChildrenRow()
  }

  /**
   * 初始化node的children项
   */
  initChildrenRow() {
    if (this.data?.children && Array.isArray(this.data.children) && this.data.children.length) {
      this.data.children = this.data.children.map((item: any) => {
        return new this.tableStore.extendRowStore(this.tableStore, item, this);
      });
      this.children = this.data.children
    }
  }

  getChild(index: number) {
    return this.data?.children?.[index]
  }

  /**
   * 获取当前节点的父节点
   * @returns nodeStore
   */
  getParent() {
    return this._parent;
  }

  /**
   * 获取当前节点的所有子节点
   * @returns 数组[nodeStore]
   */
  getChildren(): Array<NodeStore> {
    return this.data?.children
  }

  /**
   * 在当前节点插入子项
   * @param index 
   * @param node 
   * @param parentRowKey 
   */
  insertChildNode(index: number, node: any, parentNode: NodeStore) {
    // 插入行，设置数据标识
    const nodeStore: NodeStore = this.tableStore.parseTreeRow(node, parentNode);
    nodeStore.set_Status(DataState.Insert);
    this.spliceData(index, 0, nodeStore);
    return nodeStore;
  }

  /**
   * 在当前节点子项中增加node
   * @param row 
   */
  addChildNode(node: any, isInit: boolean = false): NodeStore {
    const NodeStore: NodeStore = this.tableStore.parseTreeRow(node, this);
    if (!isInit) {
      NodeStore.set_Status(DataState.Insert);
    }
    // 新增下级节点，如果children处理
    if (!this.data.children) { this.data.children = []}
    this.data.children.push(NodeStore);
    this.resetOrder()
    return NodeStore;
  }
  
  /**
   * 在当前节点删除子项
   * @param item 
   */
  deleteChildNode(item: NodeStore) {
    if (item.get_Status() === DataState.Insert) {
      return this.dropRow(item);
    }
    item.set_Status(DataState.Delete)
  }

    /**
   * 删除行（物理删）
   * @param item rowStore
   * @returns boolean
   */
  private dropRow(item: NodeStore): boolean {
    const index = this.data.children?.indexOf?.(item);
    if (!~index) return false;
    this.spliceData(index, 1);
    return true;
  }

  private spliceData(start: number, deleteCount: number, row?: NodeStore) {
    if (row) {
      this.data.children?.splice?.(start, deleteCount, row)
    } else {
      this.data.children?.splice?.(start, deleteCount)
    }
    this.resetOrder()
  }

  private resetOrder() {
    this.data.children?.map?.((row: any, index: any) => row.order = index)
  }

  get hasParent() {
    return !!this._parent
  }

} 